import { addEvent } from "../../utils/events/events";
import { onReady } from "../../utils/events/onReady";


export class Share {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(domReference));
    }

    
    shareSocialMedia(e) {
        e.preventDefault();
        // Check if there is double screen available, to avoid different sizes to the new window.
        const dualScreenLeft =
            window.screenLeft !== undefined
                ? window.screenLeft
                : window.screenX;
        const dualScreenTop =
            window.screenTop !== undefined ? window.screenTop : window.screenY;
        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : window.screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : window.screen.height;
        const systemZoom = width / window.screen.availWidth;
        const left = (width - 626) / 2 / systemZoom + dualScreenLeft;
        const top = (height - 436) / 2 / systemZoom + dualScreenTop;

        switch (e.target.id) {
            case "fb":
                let url = `https://www.facebook.com/sharer/sharer.php?u=${document.location.href}`;
                let options = `toolbar=no,menubar=no,scrollbars=no,location=no,directories=no,height=${436},width=${626},top=${top},left=${left}`;
                window.open(url, "Share on", options);
                break;
            case "ln":
                url = `https://www.linkedin.com/sharing/share-offsite/?url=${document.location.href}`;
                options = `toolbar=no,menubar=no,scrollbars=no,location=no,directories=no,height=${436},width=${626},top=${top},left=${left}`;
                window.open(url, "Share on", options);
                break;
            default:
                break;
        }
        return false;
    }

    init(domReference) {
        //add listener for each button of soMe
        const shareLinks = domReference.querySelectorAll(".button");
        shareLinks.forEach(link => {
            addEvent(link, "click", e => this.shareSocialMedia(e));
        });
    }
}
